export const EMPTY_PLAQUE_METADATA = { generationId: "", generationLabel: "", trim: "", variantId: "", color: "" };

export default function VehiclePlaqueMetadataFields({ value, onChange }) {
  return <fieldset style={{ border: "1px solid #333", borderRadius: 12, padding: 14, display: "grid", gap: 10 }}>
    <legend>Optional vehicle identity</legend>
    {[["generationLabel", "Generation", "S2"], ["generationId", "Generation matching key", "s2"],
      ["trim", "Trim", ""], ["variantId", "Artwork variant (if applicable)", ""], ["color", "Exterior color", ""]]
      .map(([key, label, placeholder]) => <label key={key} style={{ display: "grid", gap: 6, fontSize: 13 }}>
        {label}<input maxLength={80} value={value[key] || ""} placeholder={placeholder}
          onChange={(event) => onChange({ ...value, [key]: event.target.value })}
          style={{ minWidth: 0, padding: 12, background: "#111", color: "white", border: "1px solid #444", borderRadius: 8 }} />
      </label>)}
    <small>Leave unknown fields blank. VIN is managed privately in Vehicle Plaque.</small>
  </fieldset>;
}
